export const isQuextAdmin = profile => profile.type === 'SUPER_ADMIN';

export const hasAccessTo = appCode => user => user?.appCodes?.includes(appCode);
